// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4744":"3b53517f","6230":"3b53517f","8912":"3b53517f"}[chunkId] + ".chunk.css";
};